export class VerifyCodeManager {
    constructor(private containerElement: JQuery) { }

    private verifyCodeForm : JQuery<HTMLElement>;
    private submitButton : JQuery<HTMLElement>;

    public initialize() {
        var self = this;

        self.verifyCodeForm = self.containerElement.find('#verify-code-form');
        self.submitButton = self.verifyCodeForm.find('button[type="submit"]');

        self.initializeForm();

        (<any>window).initializeVerifyCode = () => {
            self.initializeForm();
        }
    }

    private initializeForm() {
        var self = this;

        self.verifyCodeForm.off('submit').on('submit', (e) => {
            self.submitButton.prop('disabled', true);
        })
    }
}